const Dialog = require('../lib/dialog').default;
const dialogUtils = require('../utils/dialogUtil');

const PAGE_SIZE = 20;
const MAX_SEARCH_SYMBOLS = 10;
const ARTICLE_NUMBER_KEY = 0;
const START_SEARCH_LENGTH = 3;
let currentPage;
let sustainabilityTranslations;

const SUS_MAPPING = {
    articleNumber: 0,
    sapName: 1,
    RecycledMaterialShare: 2,
    Recyclability: 3,
    DangerousSubstances: 4,
    MicroPlaticFibres: 5,
    CountryAssembly: 6,
    CountryStiching: 7,
    CountryFinishing: 8,
    CountryWeaving: 9,
    CountryDyingPrinting: 10,
    CountryMakingTailoring: 11,
    PackagingRecycledMaterialShare: 12,
    PackagingReUse: 13,
    PackagingRecyclability: 14,
    PackagingDangerousSubstances: 15,
    DigitalProductPassLastUpdate: 19
};

/**
 * Open specific page
 *
 * @param {number} page page to open
 */
function openPage(page) {
    currentPage = page;
    if (window.sustainabilityArticles) {
        let articles = window.sustainabilityArticles;

        const searchTerm = $('.js-sustainability-search-input').val();

        if (searchTerm.length >= START_SEARCH_LENGTH) {
            articles = articles.filter(article => {
                return article[ARTICLE_NUMBER_KEY].indexOf(searchTerm) !== -1;
            });
        }

        const articlesCount = articles.length;
        const startItem = (page - 1) * PAGE_SIZE;
        const pageArticles = articles.slice(startItem, startItem + PAGE_SIZE);
        const pagesCount = Math.floor((articlesCount + PAGE_SIZE - 1) / PAGE_SIZE);
        const previousPage = page > 1 ? page - 1 : null;
        const nextPage = page + 1 <= pagesCount ? page + 1 : null;

        const headers = window.sustainabilityArticlesHeaders;

        const previousPageButton =
            previousPage !== null
                ? `<a href="#" class="js-previous-page sustainability-pagination-arrow sustainability-pagination-arrow--left">${sustainabilityTranslations.previousPage}</a>`
                : `<a href="#" rel="nofollow" class="sustainability-pagination-arrow sustainability-pagination-arrow--left button disabled" aria-disabled="true" disabled>${sustainabilityTranslations.previousPage}</a>`;
        const nextPageButton =
            nextPage !== null
                ? `<a href="#" class="js-next-page sustainability-pagination-arrow sustainability-pagination-arrow--right">${sustainabilityTranslations.nextPage}</a>`
                : `<a href="#" rel="nofollow" class="sustainability-pagination-arrow sustainability-pagination-arrow--right button disabled" aria-disabled="true" disabled>${sustainabilityTranslations.nextPage}</a>`;

        let tableHTML = '';

        if (articlesCount) {
            tableHTML = `
                <div class="sustainability-wrapper">
                    <table class="sustainability-table">
                        <tr>
                            <th class="fixed-td fixed-hd left-top-td">${headers['sustainability.articlenumber']}</th>
                            <th class="fixed-td fixed-hd left-top-td left-top-td-2">${
                                headers['sustainability.description']
                            }</th>
                            <th class="scrollable-td fixed-hd">${headers['sustainability.dangeroussubstances']}</th>
                            <th class="scrollable-td fixed-hd">${headers['sustainability.microplaticfibres']}</th>
                            <th class="scrollable-td fixed-hd">${headers['sustainability.country.assembly']}</th>
                            <th class="scrollable-td fixed-hd">${headers['sustainability.country.stiching']}</th>
                            <th class="scrollable-td fixed-hd">${headers['sustainability.country.finishing']}</th>
                            <th class="scrollable-td fixed-hd">${headers['sustainability.traceability.weaving']}</th>
                            <th class="scrollable-td fixed-hd">${headers['sustainability.traceability.printing']}</th>
                            <th class="scrollable-td fixed-hd">${headers['sustainability.traceability.production']}</th>
                            <th class="scrollable-td fixed-hd">${headers['sustainability.recycledmaterialshare']}</th>
                            <th class="scrollable-td fixed-hd">${headers['sustainability.recyclability']}</th>
                            <th class="scrollable-td fixed-hd">${
                                headers['sustainability.packaging.reuse']
                            }</th>              
                            <th class="scrollable-td fixed-hd">${
                                headers['sustainability.packaging.dangeroussubstances']
                            }</th>
                            <th class="scrollable-td fixed-hd">${
                                headers['sustainability.packaging.recycledmaterialshare']
                            }</th>
                            <th class="scrollable-td fixed-hd">${headers['sustainability.packaging.recyclability']}</th>
                            <th class="scrollable-td fixed-hd">${
                                headers['sustainability.digitalproductpasslastupdate']
                            }</th>
                        </tr>
                        ${pageArticles
                            .map(
                                article => `
                                    <tr>
                                        <td class="fixed-td">${article[SUS_MAPPING.articleNumber]}</td>
                                        <td class="fixed-td fixed-td-2">${article[SUS_MAPPING.sapName]}
                                            <a class="sustainability-mobile-link js-sustainability-open-article" data-article-json='${JSON.stringify(
                                                article
                                            )}' href="#">
                                                <i class="icon icon-arrow_right2"></i>
                                            </a>
                                        </td>
                                        <td class="scrollable-td">${article[SUS_MAPPING.DangerousSubstances]}</td>
                                        <td class="scrollable-td">${article[SUS_MAPPING.MicroPlaticFibres]}</td>
                                        <td class="scrollable-td">${article[SUS_MAPPING.CountryAssembly]}</td>
                                        <td class="scrollable-td">${article[SUS_MAPPING.CountryStiching]}</td>
                                        <td class="scrollable-td">${article[SUS_MAPPING.CountryFinishing]}</td>
                                        <td class="scrollable-td">${article[SUS_MAPPING.CountryWeaving]}</td>
                                        <td class="scrollable-td">${article[SUS_MAPPING.CountryDyingPrinting]}</td>
                                        <td class="scrollable-td">${article[SUS_MAPPING.CountryMakingTailoring]}</td>
                                        <td class="scrollable-td">${article[SUS_MAPPING.RecycledMaterialShare]}</td>
                                        <td class="scrollable-td">${article[SUS_MAPPING.Recyclability]}</td>
                                        <td class="scrollable-td">${article[SUS_MAPPING.PackagingReUse]}</td>
                                        <td class="scrollable-td">${
                                            article[SUS_MAPPING.PackagingDangerousSubstances]
                                        }</td>
                                        <td class="scrollable-td">${
                                            article[SUS_MAPPING.PackagingRecycledMaterialShare]
                                        }</td>
                                        <td class="scrollable-td">${article[SUS_MAPPING.PackagingRecyclability]}</td>
                                        <td class="scrollable-td">${
                                            article[SUS_MAPPING.DigitalProductPassLastUpdate]
                                        }</td>
                                    </tr>
                            `
                            )
                            .join('')}
                    </table>
                </div>

                ${
                    articlesCount > PAGE_SIZE
                        ? `
                <div class="sustainability-pagination">
                    ${previousPageButton}
                    <span class="sustainability-pagination-note sustainability-pagination-note--left">${
                        sustainabilityTranslations.page
                    }</span>
                    <div class="selector">
                    <span style="user-select: none;">${currentPage}</span>
                    <select class="js-sustainability-page-selector sustainability-page-selector" style="width: 60px!important;">
                            ${[...Array(pagesCount).keys()]
                                .map(
                                    key => `
                                    <option ${key + 1 === currentPage ? 'selected="selected"' : ''} value="${
                                        key + 1
                                    }">${key + 1}</option>
                                `
                                )
                                .join('')}
                    </select>
                    </div>
                    <span class="sustainability-pagination-note sustainability-pagination-note--right">${
                        sustainabilityTranslations.of
                    } ${pagesCount}</span>
                    ${nextPageButton}
                </div>
                `
                        : ''
                }
            `;
            $('.js-no-results-info').addClass('hidden');
        } else {
            $('.js-no-results-info').removeClass('hidden');
        }

        $('.js-sustainability-wrapper').html(tableHTML);
    }
}

module.exports = {
    /**
     *
     */
    init() {
        $('body').on('click', '.sustainability-modal-link', function (e) {
            e.preventDefault();

            const dialog = new Dialog({
                additionalClasses: ['sustainability-modal'],
                canCloseOnBackdropClick: true,
                url: Urls.sustainabilityOverlay,
                useLegacyContainer: true,
                hasTitleBar: false,
                hasCloseText: false,
                callback: dialogUtils.commonDialogCallback,
                closeCallback: dialogUtils.commonDialogCloseCallback
            });

            dialog.open();
        });

        $('.sustainability-page-selector').on('change', function () {
            window.location.href = $(this).find(':selected').data('pageUrl');
        });

        $('.js-sustainability-search-input').on('keyup', function () {
            const searchTerm = $(this).val();

            // 0 is when you delete all numbers to reload the result
            if (searchTerm.length >= START_SEARCH_LENGTH || searchTerm.length === 0) {
                openPage(1);
            }
            if (searchTerm.length > 0) {
                $('.js-sustainability-button-search').addClass('hidden');
                $('.js-sustainability-clear-search').removeClass('hidden');
            } else {
                $('.js-sustainability-button-search').removeClass('hidden');
                $('.js-sustainability-clear-search').addClass('hidden');
            }
        });

        $('.js-sustainability-clear-search').on('click', () => {
            $('.js-sustainability-search-input').val('');
            $('.js-sustainability-button-search').removeClass('hidden');
            $('.js-sustainability-clear-search').addClass('hidden');
            openPage(1);
        });

        $('.js-sustainability-search-input').on('keydown', function (e) {
            const searchTerm = $(this).val();

            if (
                (searchTerm.length >= MAX_SEARCH_SYMBOLS || ['e', '+', '-', '.', 'E'].includes(e.key)) &&
                e.key !== 'Backspace' &&
                e.key !== 'Delete'
            ) {
                e.stopPropagation();
                e.preventDefault();
                return false;
            }
        });

        $('.js-sustainability-clear-search').on('click', () => {
            $('.js-sustainability-search-input').val('');
            $('.js-sustainability-button-search').removeClass('hidden');
            $('.js-sustainability-clear-search').addClass('hidden');
            openPage(1);
        });

        $('.js-sustainability-search').on('submit', e => {
            e.preventDefault();
            openPage(1);
        });

        $('.js-sustainability-wrapper').on('click', '.js-previous-page', e => {
            e.preventDefault();
            openPage(currentPage - 1);
        });

        $('.js-sustainability-wrapper').on('click', '.js-next-page', e => {
            e.preventDefault();
            openPage(currentPage + 1);
        });

        $('.js-sustainability-wrapper').on('change', '.js-sustainability-page-selector', function () {
            const selectedPage = parseInt($(this).find(':selected').val());
            openPage(selectedPage);
        });

        $('.js-sustainability-wrapper').on('click', '.js-sustainability-open-article', function (e) {
            e.preventDefault();

            const articleJson = $(this).data('articleJson');

            $('.js-sustainability-container').addClass('hidden');
            $('.js-single-product-view').removeClass('hidden');

            if (articleJson?.length) {
                for (let i = 0; i < articleJson.length; i++) {
                    $(`.js-article-field-${i}`).html(articleJson[i]);
                }
                $('.js-article-number-breadcrump').html(articleJson[ARTICLE_NUMBER_KEY]);
            }
        });

        $('.js-single-product-view').on('click', '.js-sustainability-back', function (e) {
            e.preventDefault();
            $('.js-sustainability-container').removeClass('hidden');
            $('.js-single-product-view').addClass('hidden');
        });

        sustainabilityTranslations = window.sustainabilityTranslations;
        openPage(1);
    }
};
